import React, { useState, useEffect } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { CheckCircle, XCircle, RefreshCw, Mail } from 'lucide-react';
import axios from 'axios';

export default function VerifyEmailPage() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  const [status, setStatus] = useState('loading');
  const [message, setMessage] = useState('');

  useEffect(() => {
    if (!token) {
      setStatus('error');
      setMessage('Geen verificatie token gevonden.');
      return;
    }
    (async () => {
      try {
        const r = await axios.post('/api/auth/verify-email', { token });
        setStatus('success');
        setMessage(r.data.message || 'E-mailadres bevestigd!');
      } catch (err) {
        setStatus('error');
        setMessage(err.response?.data?.detail || 'Verificatie mislukt. De link is mogelijk verlopen.');
      }
    })();
  }, [token]);

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#f8fafc', padding: '20px' }}>
      <motion.div
        initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }}
        style={{ background: 'white', borderRadius: '20px', padding: '40px', maxWidth: '440px', width: '100%', textAlign: 'center', boxShadow: '0 4px 24px rgba(0,0,0,0.06)' }}
      >
        {status === 'loading' && (
          <>
            <RefreshCw size={40} style={{ color: '#D4A017', animation: 'spin 1s linear infinite', margin: '0 auto 16px' }} />
            <h2 style={{ fontFamily: "'Sora', sans-serif", fontSize: '20px', fontWeight: 800, color: '#0f172a', marginBottom: '8px' }}>
              E-mail verifiëren...
            </h2>
            <p style={{ color: '#64748b', fontSize: '14px' }}>Even geduld.</p>
          </>
        )}
        {status === 'success' && (
          <>
            <div style={{ width: '64px', height: '64px', borderRadius: '50%', background: '#f0fdf4', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 16px' }}>
              <CheckCircle size={32} style={{ color: '#22c55e' }} />
            </div>
            <h2 data-testid="verify-success" style={{ fontFamily: "'Sora', sans-serif", fontSize: '20px', fontWeight: 800, color: '#0f172a', marginBottom: '8px' }}>
              E-mail bevestigd!
            </h2>
            <p style={{ color: '#64748b', fontSize: '14px', marginBottom: '24px' }}>{message}</p>
            <Link to="/platform" style={{
              display: 'inline-flex', alignItems: 'center', gap: '8px', background: '#0f172a', color: 'white',
              padding: '12px 24px', borderRadius: '10px', textDecoration: 'none', fontSize: '14px', fontWeight: 700,
            }}>
              Naar uw dashboard
            </Link>
          </>
        )}
        {status === 'error' && (
          <>
            <div style={{ width: '64px', height: '64px', borderRadius: '50%', background: '#fef2f2', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 16px' }}>
              <XCircle size={32} style={{ color: '#ef4444' }} />
            </div>
            <h2 data-testid="verify-error" style={{ fontFamily: "'Sora', sans-serif", fontSize: '20px', fontWeight: 800, color: '#0f172a', marginBottom: '8px' }}>
              Verificatie mislukt
            </h2>
            <p style={{ color: '#64748b', fontSize: '14px', marginBottom: '24px' }}>{message}</p>
            <Link to="/login" style={{
              display: 'inline-flex', alignItems: 'center', gap: '8px', background: '#0f172a', color: 'white',
              padding: '12px 24px', borderRadius: '10px', textDecoration: 'none', fontSize: '14px', fontWeight: 700,
            }}>
              Naar inloggen
            </Link>
          </>
        )}
      </motion.div>
    </div>
  );
}
